"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInsightsLogger = void 0;
const logLevel_1 = require("./logLevel");
const abstractStringLogger_1 = require("./abstractStringLogger");
const Contracts_1 = require("applicationinsights/out/Declarations/Contracts");
const argumentError_1 = require("../utils/argumentError");
const guard_1 = require("../utils/guard");
/**
 * Logger that logs to Azure Application Insights
 */
class AppInsightsLogger extends abstractStringLogger_1.AbstractStringLogger {
    /**
     * Initializes a new instance of the @see ConsoleLogger class.
     * @param minimumLevel The minimum log level this logger accepts for log messages. If not set, LogLevel.Trace will be used.
     */
    constructor(client, minimumLevel) {
        super(minimumLevel || logLevel_1.LogLevel.Trace);
        guard_1.Guard.throwIfNullOrEmpty(client, 'client');
        this.client = client;
    }
    /**
     * The real handler for log entries.
     * @param logLevel Entry will be written on this level.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    logHandler(logLevel, requestId, state, error, formatter) {
        const telemetry = {
            message: formatter(state, requestId, error),
            severity: AppInsightsLogger.logLevelToSeverityLevel(logLevel),
        };
        this.client.trackTrace(telemetry);
    }
    /**
     * Converts an internal log level to an Application Insights severity level.
     * @param logLevel Log level to convert.
     * @returns Application Insights severity level.
     */
    static logLevelToSeverityLevel(logLevel) {
        switch (logLevel) {
            case logLevel_1.LogLevel.None:
            case logLevel_1.LogLevel.Trace:
                return Contracts_1.SeverityLevel.Verbose;
            case logLevel_1.LogLevel.Debug:
                return Contracts_1.SeverityLevel.Verbose;
            case logLevel_1.LogLevel.Information:
                return Contracts_1.SeverityLevel.Information;
            case logLevel_1.LogLevel.Warning:
                return Contracts_1.SeverityLevel.Warning;
            case logLevel_1.LogLevel.Error:
            case logLevel_1.LogLevel.Critical:
                return Contracts_1.SeverityLevel.Error;
            default:
                throw new argumentError_1.ArgumentError('Unkown log level', 'logLevel');
        }
    }
}
exports.AppInsightsLogger = AppInsightsLogger;
//# sourceMappingURL=appInsightsLogger.js.map